require('./emitedTransfersContentTable.scss');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @ commons
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const EmitedTransfersContentTableRow = require('../emitedTransfersContentTableRow/emitedTransfersContentTableRow');
const { EmitedTransfersContentTableInfoRow } = require('../emitedTransfersContentTableInfoRow/emitedTransfersContentTableInfoRow');

// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();


class EmitedTransfersContentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expandedRowId: '' };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
    }

    buildNextPageButton() {
        const { immAccountEmitedTransfers } = this.props;
        let buttonContent;
        if (immAccountEmitedTransfers.get('nextPage')) {
            if (immAccountEmitedTransfers.get('loadingNextPage')) {
                buttonContent = <LoadingSection />;
            } else {
                buttonContent = (
                    <div className="emited-transfers-content-table__more-movements">
                        <OKButton
                            modifier="link-complementary"
                            onClick={this.handleNextPage}
                        >
                            <FormattedText value="transfersEmited-seeMore" />
                        </OKButton>
                    </div>
                );
            }
        }
        return buttonContent;
    }

    handleNextPage() {
        const { accountId, requestEmitedTransfersNextPage } = this.props;
        requestEmitedTransfersNextPage(accountId);
    }

    handleRowClick(rowId) {
        this.setState({
            expandedRowId: rowId === this.state.expandedRowId ? '' : rowId
        });
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true} className="scheduled-transfers-table__table-header-row-line">
                        <OKTableCell
                            asHeader={true}
                            className="scheduled-transfers-table__table-header-cell-line"
                            colSpan={2}
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell
                            asHeader={true}
                            className="emited-transfers-content-table__header-cell"
                        />
                        <OKTableCell
                            asHeader={true}
                            className="emited-transfers-content-table__header-cell"
                        >
                            <FormattedText value="transfersEmitted-date" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="emited-transfers-content-table__header-cell"
                        >
                            <FormattedText
                                value="transfersLanding-beneficiary"
                                format="uppercase"
                            />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="emited-transfers-content-table__header-cell"
                        >
                            <FormattedText
                                value="transfersLanding-concept"
                                format="uppercase"
                            />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="emited-transfers-content-table__header-cell--amount"
                        >
                            <FormattedText value="transfersLanding-amount" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="emited-transfers-content-table__header-cell"
                        />
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    render() {
        const { immAccountEmitedTransfers, immScreen } = this.props;
        const immAccountEmitedTransfersByOrder = immAccountEmitedTransfers.get('byOrder');
        const immAccountEmitedTransfersById = immAccountEmitedTransfers.get('byId');
        const { expandedRowId } = this.state;
        const nextPageButton = this.buildNextPageButton();
        const tableHead = this.buildTableHead();
        const columnsCount = immScreen.get('isMobile') ? 3 : 7;

        return (
            <div className="emited-transfers-table">
                <LastMovementsTable
                    groupByDate
                    rowComponent={EmitedTransfersContentTableRow}
                    immTransactionsByOrder={immAccountEmitedTransfersByOrder}
                    immTransactionsById={immAccountEmitedTransfersById}
                    columnsCount={columnsCount}
                    expandedRowId={expandedRowId}
                    expandedRowComponent={EmitedTransfersContentTableInfoRow}
                    onRowClick={this.handleRowClick}
                    id="emited-transfers-table"
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    {tableHead}
                </LastMovementsTable>
                {nextPageButton}
            </div>
        );
    }
}

EmitedTransfersContentTable.propTypes = {
    immAccountEmitedTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    resultsLimit: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    requestEmitedTransfersNextPage: PropTypes.func.isRequired
};

module.exports = EmitedTransfersContentTable;
